document.addEventListener('DOMContentLoaded', function() {
  const root = document.querySelector('.main-blog__layout');
  if (!root) return;

  const blogUrl = root.getAttribute('data-blog-url') || window.location.pathname.split('/tagged')[0];
  const checkboxes = Array.from(document.querySelectorAll('.blog-filter__checkbox-input'));
  const searchInput = document.getElementById('blog-filter-search');
  const clearSearchBtn = document.querySelector('[data-clear="search"]');
  const articlesWrapper = document.getElementById('blog-articles');
  const countNode = document.getElementById('blog-filter-count');
  const drawer = document.getElementById('blog-filter-drawer');
  const openBtn = document.querySelector('.blog-filter__open-btn');
  const closeBtn = document.querySelector('.blog-filter__close-btn');
  const overlay = document.querySelector('.blog-filter__overlay');
  const activeFiltersContainer = document.getElementById('active-filter-items');

  function navigateToTags() {
    const selected = checkboxes.filter(c => c.checked).map(c => c.value).filter(Boolean);
    if (selected.length === 0) {
      window.location.href = blogUrl;
    } else {
      // Shopify expects handleized tags separated by '+'
      window.location.href = blogUrl.replace(/\/$/, '') + '/tagged/' + selected.join('+');
    }
  }

  function getActiveTagsFromUrl() {
    const path = window.location.pathname;
    const taggedMatch = path.match(/\/tagged\/(.+)/);
    if (!taggedMatch) return [];
    return taggedMatch[1].split('+').map(tag => tag.trim()).filter(Boolean);
  }

  function updateActiveFilters() {
    if (!activeFiltersContainer) return;
    const activeTags = getActiveTagsFromUrl();
    
    // Clear existing items
    activeFiltersContainer.innerHTML = '';
    
    // Add active filter items
    activeTags.forEach(tagHandleized => {
      // Find the original tag name from checkboxes
      const checkbox = checkboxes.find(cb => cb.value === tagHandleized);
      const tagName = checkbox ? checkbox.closest('.blog-filter__checkbox').querySelector('.blog-filter__checkbox-label').textContent.trim() : tagHandleized;
      
      const filterItem = document.createElement('div');
      filterItem.className = 'active-filter__item';
      filterItem.setAttribute('data-tag', tagHandleized);
      
      filterItem.innerHTML = `
        <span class="active-filter__label">${tagName}</span>
        <button type="button" class="active-filter__remove" aria-label="Remove ${tagName} filter">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M9 3L3 9M3 3L9 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      `;
      
      activeFiltersContainer.appendChild(filterItem);
    });
    
    // Add event listeners to remove buttons
    activeFiltersContainer.querySelectorAll('.active-filter__remove').forEach(btn => {
      btn.addEventListener('click', function() {
        const filterItem = this.closest('.active-filter__item');
        const tagToRemove = filterItem.getAttribute('data-tag');
        removeTagFilter(tagToRemove);
      });
    });
  }

  function removeTagFilter(tagToRemove) {
    const currentActiveTags = getActiveTagsFromUrl();
    const updatedTags = currentActiveTags.filter(tag => tag !== tagToRemove);
    
    // Update checkboxes to reflect removal
    checkboxes.forEach(cb => {
      if (cb.value === tagToRemove) {
        cb.checked = false;
      }
    });
    
    // Navigate to updated URL
    if (updatedTags.length === 0) {
      window.location.href = blogUrl;
    } else {
      window.location.href = blogUrl.replace(/\/$/, '') + '/tagged/' + updatedTags.join('+');
    }
  }

  checkboxes.forEach(cb => {
    cb.addEventListener('change', navigateToTags);
  });

  function applyClientSearch() {
    if (!articlesWrapper) return;
    const q = (searchInput?.value || '').trim().toLowerCase();
    let visible = 0;
    Array.from(articlesWrapper.children).forEach(item => {
      if (!(item instanceof HTMLElement)) return;
      const title = (item.getAttribute('data-title') || '').toLowerCase();
      const tags = (item.getAttribute('data-tags') || '').toLowerCase();
      const match = q === '' || title.includes(q) || tags.includes(q);
      item.style.display = match ? '' : 'none';
      if (match) visible += 1;
    });
    if (countNode) countNode.textContent = String(visible);
  }

  if (searchInput) {
    searchInput.addEventListener('input', applyClientSearch);
  }
  if (clearSearchBtn) {
    clearSearchBtn.addEventListener('click', function() {
      if (searchInput) {
        searchInput.value = '';
        applyClientSearch();
      }
    });
  }

  // Initial setup
  updateActiveFilters();
  applyClientSearch();

  // Drawer behavior (mobile only)
  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) {
      overlay.classList.add('active');
      overlay.removeAttribute('hidden');
    }
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) {
      overlay.classList.remove('active');
      overlay.setAttribute('hidden', '');
    }
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  openBtn?.addEventListener('click', openDrawer);
  closeBtn?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });
});